<template>
    <page :showDashboardButton="true">
        <!-- <h1>me1ns</h1> -->
        <slider currentPage="me1ns" />
        <ion-grid>
            <ion-row>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'me1nzuhause' }"
                        icon="flame"
                        title="me1n Zuhause"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'my21' }"
                        icon="flame"
                        title="MY 21"
                    />
                </ion-col>
                <!-- <ion-col size="4">
                    <pagelink
                        :path="{ name: 'services-schmerzlinderung' }"
                        icon="flame"
                        title="Windhund"
                    />
                </ion-col> -->
                <ion-col size="4">
                    <pagelink
                        path="https://www.klickmal.at/pages/lebenscheck.html"
                        icon="flame"
                        title="Lebenscheck"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Pagelink from "@/components/Pagelink";
import Slider from "@/components/Slider";

export default {
    components: { Page, Pagelink, Slider },
};
</script>

<style></style>
